<template>
  <div>
    <audio ref="audio" hidden="hidden" id='MessageAudio'>
      <source src="../../../assets/mp3/t.mp3"/>
    </audio>

    
    <a-table bordered
             :loading="loading"
             :columns="visibleColumns"
             :data-source="deviceList"
             :pagination="pagination"
             :scroll="{ x: tableScrollX }"
             @change="handleTableChange"
    >
      <template slot="state" slot-scope="state, record">
        <!--        <a-tag v-if="state==1" color="green" style="width: 50px;height: 30px;line-height: 30px;text-align: center;font-size: 12px">开启中</a-tag>-->
        <!--        <a-tag v-else style="width: 50px;height: 30px;line-height: 30px;text-align: center;font-size: 12px">关闭中</a-tag>-->
        <a-popconfirm
          :title="'确定'+(state===1?'关闭':'开启')+'设备？'"
          ok-text="确定"
          cancel-text="取消"
          @confirm="changeState(record)"
        >
          <a-switch  v-if="hasPerm('/device/updateDeviceVptinfo')" checked-children="开" un-checked-children="关" :checked="state===1"/>
        </a-popconfirm>


      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" v-if="hasPerm('/device/getDeviceVptinfoById')" class="margin-right-30" @click="lookDeviceInfo(record)">查看</a>
        <a href="javascript:;" v-if="hasPerm('/device/executeDeviceCmd')" class="margin-right-30" @click="opnDeviceCmd(record)">指令</a>
<!--        <a href="javascript:;" v-if="hasPerm('/device/executeDeviceCmd')||hasPerm('/device/updateDeviceVptinfo')" class="margin-right-30" @click="openBluetooth(record)">蓝牙</a>-->
        <a href="javascript:;" v-if="hasPerm('/device/deleteDeviceVptinfoById/')" style="color: #E84D11;" @click="delDevice(record)">删除</a>
      </template>
    </a-table>
    <!-- 删除弹窗 -->
    <a-modal v-model="DELvisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="DelSpinning">
        <div class="delDevice">
          <div class="DelTitle">删除</div>
          <img src="~@/assets/image/common/DelHint.png" class="delIcon" alt=""/>
          <div class="delHint">是否删除{{ DELdeviceName }}</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
            <a-button class="confirm" @click="confirm">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal v-model="deviceinfoVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="infoSpinning">
        <div class="deviceInfo-title">设备详情</div>
        <a-form-model ref="deviceInfo" v-bind="layout" :model="deviceInfo" :rules="deviceInfoFormRules">
          <a-form-model-item has-feedback label="出厂编码" prop="deviceNum">
            <a-input v-model="deviceInfo.deviceNum" type="text" autocomplete="off" :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="站点编码" prop="vptCode">
            <a-input v-model="deviceInfo.vptCode" type="text" autocomplete="off" :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="设备编码" prop="vptNum">
            <a-input v-model="deviceInfo.vptNum" type="text" autocomplete="off" :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="IMEI" prop="name">
            <a-input v-model="deviceInfo.name" type="text" autocomplete="off" :disabled="true"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="设备类型" prop="deviceType">
            <a-radio-group v-model="deviceInfo.deviceType" :disabled="!btnShow">
              <a-radio :value="1">RTU</a-radio>
              <a-radio :value="2">电子锁</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item has-feedback label="地理位置" prop="pos">
            <a-input v-model="deviceInfo.pos" type="text" autocomplete="off" :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="控制指令" prop="cmd">
            <a-input v-model="deviceInfo.cmd" type="text" autocomplete="off" :disabled="!btnShow"/>
          </a-form-model-item>

          <!--            <a-form-model-item has-feedback label="设备状态" prop="state">-->
          <!--              <a-radio-group v-model="deviceInfo.state" :disabled="!btnShow">-->
          <!--                <a-radio :value="0">-->
          <!--                  关-->
          <!--                </a-radio>-->
          <!--                <a-radio :value="1">-->
          <!--                  开-->
          <!--                </a-radio>-->
          <!--              </a-radio-group>-->
          <!--            </a-form-model-item>-->

          <a-form-model-item has-feedback label="蓝牙名称" prop="nameB">
            <a-input v-model="deviceInfo.nameB" type="text" autocomplete="off" :disabled="!btnShow" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="SIM卡号" prop="ccidB">
            <a-input v-model="deviceInfo.ccidB" type="text" autocomplete="off" :disabled="!btnShow" />
          </a-form-model-item>

<!--          <a-form-model-item has-feedback label="广播名称" prop="localNameB">-->
<!--            <a-input v-model="deviceInfo.localNameB" type="text" autocomplete="off" :disabled="!btnShow" />-->
<!--          </a-form-model-item>-->

<!--          <a-form-model-item has-feedback label="物理地址" prop="deviceIdB">-->
<!--            <a-input v-model="deviceInfo.deviceIdB" type="text" autocomplete="off" :disabled="!btnShow" />-->
<!--          </a-form-model-item>-->

          <a-form-model-item has-feedback label="IMEI编码" prop="imeiB">
            <a-input v-model="deviceInfo.imeiB" type="text" autocomplete="off" :disabled="!btnShow" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="蓝牙备注" prop="remarkB">
            <a-input v-model="deviceInfo.remarkB" type="text" autocomplete="off" :disabled="!btnShow" />
          </a-form-model-item>

        </a-form-model>

        <div class="deviceInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="DeviceInfoCancel">取消</a-button>
          <a-button class="btn btn-active" v-if="!btnShow && hasPerm('/device/updateDeviceVptinfo')" @click="DeviceInfoEdit">修改</a-button>
          <a-popconfirm
            title="确定提交修改吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="confirmEdit('deviceInfo')"
            @cancel=""
          >
            <a-button class="btn btn-active" v-if="btnShow">提交</a-button>
          </a-popconfirm>
        </div>
      </a-spin>
    </a-modal>
    <!-- 执行指令 -->
    <a-modal v-model="deviceCmdVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="false">
        <div class="deviceInfo-title">执行指令</div>
        <a-form-model ref="deviceInfo" v-bind="layout" :model="deviceInfo">
          <a-form-model-item has-feedback label="站点编码" prop="vptCode">
            <a-input v-model="deviceInfo.vptCode" type="text" autocomplete="off" :disabled="true"/>
          </a-form-model-item>
          <a-form-model-item has-feedback label="设备编码" prop="vptNum">
            <a-input v-model="deviceInfo.vptNum" type="text" autocomplete="off" :disabled="true"/>
          </a-form-model-item>
          <a-form-model-item has-feedback label="IMEI" prop="name">
            <a-input v-model="deviceInfo.name" type="text" autocomplete="off" :disabled="true"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="控制指令" prop="cmd">
            <a-input v-model="deviceInfo.cmd" type="text" autocomplete="off"/>
          </a-form-model-item>

        </a-form-model>

        <div class="deviceInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="DeviceCmdCancel">取消</a-button>
          <a-popconfirm
            title="确定执行指令吗？"
            ok-text="执行"
            cancel-text="取消"
            @confirm="execDeviceCmd(deviceInfo)"
            @cancel=""
          >
            <a-button class="btn btn-active">执行</a-button>
          </a-popconfirm>
        </div>
      </a-spin>
    </a-modal>
    <!-- 蓝牙模式 -->
    <a-modal v-model="bluetoothVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="false">
        <div class="deviceInfo-title">蓝牙模式</div>
        <a-form-model ref="deviceInfo" v-bind="layout" :model="deviceInfo">
          <a-form-model-item has-feedback label="设备编号" prop="vptNum">
            <a-input v-model="deviceInfo.vptNum" type="text" autocomplete="off" :disabled="true"/>
          </a-form-model-item>
          <a-form-model-item has-feedback label="连接状态" prop="vptNum">
            <a-tag color="green">已连接</a-tag>
            <a-tag color="blue">未连接</a-tag>
          </a-form-model-item>
          <a-form-model-item has-feedback label="连接操作" prop="vptNum">
            <a-button class="btn margin-right-15" type="primary">连接设备</a-button><a-button class="btn margin-right-15" type="danger">断开设备</a-button>
          </a-form-model-item>
          <a-form-model-item has-feedback label="数据接收" prop="cmd">
            <a-textarea :auto-size="{ minRows: 3}" v-model="deviceInfo.cmd" type="text" autocomplete="off" :disabled="true"/>
          </a-form-model-item>
          <a-form-model-item has-feedback label="数据发送" prop="cmd">
            <a-textarea :auto-size="{ minRows: 3}" v-model="deviceInfo.cmd" type="text" autocomplete="off"/>
          </a-form-model-item>
          <a-form-model-item has-feedback label="数据操作" prop="vptNum">
            <a-button class="btn margin-right-15" type="primary">发送数据</a-button><a-button class="btn" type="danger">清空接收</a-button>
          </a-form-model-item>
        </a-form-model>

        <div class="deviceInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="BluetoothCancel">取消</a-button>
<!--          <a-popconfirm-->
<!--              title="确定执行指令吗？"-->
<!--              ok-text="执行"-->
<!--              cancel-text="取消"-->
<!--              @confirm="execDeviceCmd(deviceInfo)"-->
<!--              @cancel=""-->
<!--          >-->
<!--            <a-button class="btn btn-active">执行</a-button>-->
<!--          </a-popconfirm>-->
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import {DelDevice, DeviceInfo, DeviceList, execDeviceCmd, upDataDeviceInfo} from "api/device";
import {EventSourcePolyfill} from "event-source-polyfill";
import {hasPermission} from 'utils/hasPermission';


const allColumns = [
  {key: 'objectid', title: "设备id", align: "center", width: 80, dataIndex: 'objectid', perm: '/device/column/objectid'},
  {key: 'deviceNum', title: "出厂编码", align: "center", width: 120, dataIndex: 'deviceNum', perm: '/device/column/deviceNum'},
  {key: 'vptCode', title: "站点编码", align: "center", width: 180, dataIndex: 'vptCode', perm: '/device/column/vptCode'},
  {key: 'vptNum', title: "设备编码", align: "center", width: 180, dataIndex: 'vptNum', perm: '/device/column/vptNum'},
  {key: 'name', title: "IMEI", align: "center", width: 180, dataIndex: 'name', perm: '/device/column/name'},
  {key: 'nameB', title: "蓝牙名称", align: "center", dataIndex: 'nameB', ellipsis: true, perm: '/device/column/nameB'},
  {key: 'pos', title: "地理位置", align: "center", dataIndex: 'pos', ellipsis: true, perm: '/device/column/pos'},
  {key: 'cmd', title: "控制指令", align: "center", dataIndex: 'cmd', ellipsis: true, perm: '/device/column/cmd'},
  {key: 'cmdDate', title: '指令执行时间', align: "center", dataIndex: 'cmdDate', ellipsis: true, perm: '/device/column/cmdDate'},
  {key: 'state', title: "状态", align: "center", width: 180, dataIndex: 'state', scopedSlots: {customRender: 'state'}, perm: '/device/column/state'},
  {key: 'operation', title: '操作', align: "center", width: 300, dataIndex: 'operation', scopedSlots: {customRender: 'operation'}, fixed: 'right', perm: null}
];

export default {
  name: 'DeviceTable',
  data() {
    let checkPending;
    let validateVptNum = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('设备编号不能为空'));
      } else {
        callback();
      }
    };
    let validateName = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('IMEI不能为空'));
      } else {
        callback();
      }
    };
    let validateNameB = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('蓝牙名称不能为空'));
      } else {
        callback();
      }
    };
    return {
      allColumns,
      pagination: {
        defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      layout: {
        labelCol: {span: 4},
        wrapperCol: {span: 20},
      },

      loading: false,
      DelSpinning: false,
      infoSpinning: false,

      pageIndex: 0,
      pageSize: 10,
      deviceName: "",

      deviceList: [],

      DELvisible: false,
      DELdeviceName: "",
      DELdeviceId: Number,

      deviceinfoVisible: false,
      deviceInfo: {
        id: "",
        deviceNum: "",
        deviceName: "",
        tel: "",
        deviceUid: "",
        password: "",
      },
      deviceInfoFormRules: {
        vptNum: [{validator: validateVptNum, trigger: 'change'}],
        name: [{validator: validateName, trigger: 'change'}],
        // nameB: [{validator: validateNameB, trigger: 'change'}]
      },
      btnShow: false,
      //sse
      // eventSource: {},
      //cmd
      deviceCmdVisible: false,
      deviceCmd: '',

      // 蓝牙
      bluetoothVisible: false,



    };
  },
  computed: {
    visibleColumns() {
      return allColumns.filter(col => !col.perm || hasPermission(col.perm));
    },
    tableScrollX() {
      const totalWidth = this.visibleColumns.reduce((sum, col) => {
        return sum + (Number(col.width) || 160);
      }, 0);
      return Math.max(totalWidth, 1200);
    }
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
     *逻辑区
     */
    //搜索
    onSearch(value){
      if (this.deviceName === value){
        this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
      }else {
        this.deviceName = value
        this.pageIndex = 1
        this.pagination.current = 1;
        this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
      }

    },
    //修改设备状态
    changeState(deviceInfo) {
      let objectid = deviceInfo.objectid
      let deviceNum = deviceInfo.deviceNum
      let vptNum = deviceInfo.vptNum
      let name = deviceInfo.name
      let pos = deviceInfo.pos
      let state;
      if (deviceInfo.state == 1) {
        state = 0
      } else {
        state = 1
      }
      let cmd = deviceInfo.cmd
      let isListener = true
      let nameB = deviceInfo.nameB
      let localNameB = deviceInfo.localNameB
      let deviceIdB = deviceInfo.deviceIdB
      let imeiB = deviceInfo.imeiB
      let ccidB = deviceInfo.ccidB
      let remarkB = deviceInfo.remarkB
      this.setEditDevice(objectid, deviceNum, vptNum, name, pos, state, cmd, null, isListener,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB)
    },
    // 表格页面跳转
    handleTableChange(pagination, filters, sorter) {
      const pager = {...this.pagination};
      console.log("pagination------------", pagination)
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pagination.current
      this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
    },
    // 删除
    delDevice(record) {
      this.DELvisible = !this.DELvisible;
      this.DELdeviceName = record.name;
      this.DELdeviceId = record.objectid;
    },
    // 取消删除
    cancel() {
      this.DELvisible = !this.DELvisible;
    },
    // 查看设备信息
    lookDeviceInfo(record) {
      this.getDeviceInfo(record.objectid);
      this.deviceinfoVisible = true;
    },
    // 打开执行指令
    opnDeviceCmd(record) {
      this.deviceInfo = {
        objectid:record.objectid,
        vptCode:record.vptCode,
        vptNum:record.vptNum,
        name:record.name,
        state:record.state,
        cmd:record.cmd,
      }
      this.deviceCmdVisible = true;
    },
    // 修改
    DeviceInfoEdit() {
      this.btnShow = true
    },
    // 取消
    DeviceInfoCancel() {
      this.deviceinfoVisible = false;
      this.btnShow = false;
      this.deviceInfo = {
        id: "",
        deviceName: "",
        tel: "",
        deviceUid: "",
        password: "",
      }
    },
    // 取消
    DeviceCmdCancel() {
      this.deviceCmdVisible = false;
      this.deviceInfo = {
        id: "",
        deviceName: "",
        deviceNum: "",
        tel: "",
        deviceUid: "",
        password: "",
      }
    },
    // 确定修改
    confirmEdit(formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let objectid = that.deviceInfo.objectid
          let deviceNum = that.deviceInfo.deviceNum
          let vptCode = that.deviceInfo.vptCode
          let vptNum = that.deviceInfo.vptNum
          let name = that.deviceInfo.name
          let pos = that.deviceInfo.pos
          let state = that.deviceInfo.state
          let cmd = that.deviceInfo.cmd
          let isListener = false
          let nameB = that.deviceInfo.nameB
          let localNameB = that.deviceInfo.localNameB
          let deviceIdB = that.deviceInfo.deviceIdB
          let imeiB = that.deviceInfo.imeiB
          let ccidB = that.deviceInfo.ccidB
          let remarkB = that.deviceInfo.remarkB
          let deviceType = that.deviceInfo.deviceType

          this.setEditDevice(objectid, deviceNum, vptNum, name, pos, state, cmd, null, isListener,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB,vptCode,deviceType)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //
    /**
     *接口区
     */
    SocketTask(vptNum, name, state, type, historyId, otherData){
      const _that = this
      if (state == 0){
        return
      }
      // 根据环境的不同，变更url
      let url;
      if (process.env.NODE_ENV !== 'production') {
        url = 'ws://localhost:8899/back-office/api/websocket/' + name + '-' + state
      } else {
        url = 'ws://114.117.192.41:8010/back-office/api/websocket/' + name + '-' + state
      }
      const ws = new WebSocket(url);
      //连接
      ws.onopen = () => {
        console.log('WebSocket已连接');
        let data = {
          vptNum: name,
          state,
          type,
          historyId,
          otherData
        }
        ws.send(JSON.stringify(data));
      };

      //接收信息
      ws.onmessage = e => {
        console.log(`收到消息：${e.data}`);
        //监听 WebSocket 接受到服务器的消息事件
        console.log(e, '服务器的消息')
        _that.$refs.audio.play();
        let data = JSON.parse(e.data);
        console.log("已接受到消息2:", data)
        if (data.code == 1) {
          _that.$notification['success']({
            message: '收到设备反馈信息',
            description: data.data.message,
            duration: 0,
          });
          _that.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
        } else if (data.code == 0 || data.code == -1) {
          _that.$notification['error']({
            message: '收到设备反馈信息',
            description: data.data.message,
            duration: 0,
          });
          _that.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
        } else if (data.code == 500) {
          _that.$notification['error']({
            message: '收到服务器消息',
            description: data.data.message,
            duration: 0,
          });
        }else {
          _that.$notification['error']({
            message: 'SSE 连接出错',
            description: data.data.message,
            duration: 0,
          });
        }
        ws.close()
      };
      //关闭
      ws.onclose = () => console.log('WebSocket已关闭');
    },
    //获取列表数据
    getDeviceListData(pageIndex, pageSize, deviceName) {
      console.log("getDeviceListData==========", pageIndex, pageSize, deviceName)
      this.loading = true;
      DeviceList(pageIndex, pageSize, deviceName)
          .then(res => {
            console.log(res.data);
            if (res.data.rows.length > 0) {
              this.pagination.total = res.data.total;
              this.deviceList = res.data.rows;
              this.loading = false;
              this.pageIndex = pageIndex;
              this.pagination.current = pageIndex;
            } else {
              this.loading = false;
              this.pagination.total = 0;
              this.deviceList = []
              this.$message.error('没有查询到结果，请重试！');

            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          })
    },
    // 确定删除
    confirm() {
      let that = this
      that.DelSpinning = true
      DelDevice(this.DELdeviceId)
          .then(res => {
            console.log(res);
            that.$message.success(res.message);
            that.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName);
            that.DelSpinning = false;
            that.DELvisible = false;
          })
          .catch(err => {
            console.log(err);
            that.DelSpinning = false;
            that.DELvisible = false;
            that.$message.error(err.message);
          })
    },
    // 查询设备信息
    getDeviceInfo(id) {
      this.infoSpinning = true;
      DeviceInfo(id)
          .then(res => {
            this.infoSpinning = false;
            console.log(res);
            this.deviceInfo = res.data
          })
          .catch(err => {
            this.infoSpinning = false;
            console.log(err);
          })
    },
    // 修改设备信息
    setEditDevice(objectid, deviceNum, vptNum, name, pos, state, cmd, cmdDate, isListener = false,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB, vptCode, deviceType) {
      console.log(111);
      this.DelSpinning = true;
      upDataDeviceInfo(objectid, deviceNum, vptNum, name, pos, state, cmd, cmdDate, isListener,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB, vptCode, deviceType)
          .then(res => {
            this.DelSpinning = false;
            console.log(res);
            if (res.code == 0) {
              if (isListener) {
                // this.sse(vptNum, name, state);
                // vptNum, name, state, type, historyId, otherData
                this.SocketTask(vptNum, name, state, '', res.data, '');
              }
              this.$message.success('操作成功');
              this.deviceinfoVisible = false
              this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
              this.btnShow = false;
              this.deviceInfo = {
                id: "",
                deviceName: "",
                tel: "",
                deviceUid: "",
                password: "",
              }
            } else {
              this.DelSpinning = false;
              console.log("res.code != 0 :", res);
              this.$message.error('操作失败,请重试');
            }
          })
          .catch(err => {
            this.DelSpinning = false;
            console.log(err);
            this.$message.error('操作失败,请重试');
          })
    },
    // 控制指令
    execDeviceCmd(re) {
      console.log(11132323232);
      if (!re.cmd || re.cmd.toString().trim() == ''){
        this.$message.error('控制指令为空');
        return ;
      }
      execDeviceCmd(re.objectid, re.vptNum, re.name, re.pos, re.state, re.cmd, re.cmdDate)
          .then(res => {
            console.log(res);
            if (res.code == 0) {
              // if (isListener) {
              // this.sse(re.vptNum, re.name, re.cmd);
              // vptNum, name, state, type, historyId, otherData
              this.SocketTask(re.vptNum, re.name, re.cmd, 'cmd', '', res.data);
              // }
              this.$message.success('操作成功');
              this.deviceCmdVisible = false

            } else {
              console.log("res.code != 0 :", res);
              this.$message.error('操作失败,请重试');
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error('操作失败,请重试');
          })
    },
    //数字格式化
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
    // 蓝牙模式
    openBluetooth(record) {
      this.deviceInfo = {
        objectid:record.objectid,
        vptNum:record.vptNum,
        state:record.state,
        cmd:record.cmd,
      }
      this.bluetoothVisible = true;
    },
    // 取消
    BluetoothCancel() {
      this.bluetoothVisible = false;
      this.deviceInfo = {
        id: "",
        deviceName: "",
        tel: "",
        deviceUid: "",
        password: "",
      }
    },



  },
  mounted() {
    this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName);
  }
}
</script>

<style lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delDevice {
  text-align: center;

  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }

  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }

  .delHint {
    color: #212121;
    font-size: 36px;
    line-height: 90px;
  }

  .btn-wrap {
    text-align: center;

    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}

.deviceInfo-title {
  line-height: 45px;
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
}

.deviceInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;

  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
</style>
